// Contatos do embarcador (PO1-3384, H3): quem recebe e-mails do embarcador sem
// ter usuário no Hub. Rotas /embarcador-contatos/* do backend_hub (instância
// `api`); o embarcador vai explícito (o selecionado no topo).
import api from "./api";

export async function listarTiposContatoEmbarcador() {
  const { data } = await api.get("/embarcador-contatos/tipos-contato");
  return data;
}

export async function listarContatosEmbarcador(embarcadorId) {
  const { data } = await api.get("/embarcador-contatos", { params: { embarcadorId } });
  return data;
}

export async function criarContatoEmbarcador(dados) {
  const { data } = await api.post("/embarcador-contatos", dados);
  return data;
}

export async function atualizarContatoEmbarcador(id, dados) {
  const { data } = await api.put(`/embarcador-contatos/${id}`, dados);
  return data;
}

export async function removerContatoEmbarcador(id, embarcadorId) {
  const { data } = await api.delete(`/embarcador-contatos/${id}`, { params: { embarcadorId } });
  return data;
}

// Mensagem de erro do backend (error + errors por campo) ou um texto padrão.
export function mensagemErroContato(err, padrao) {
  const data = err && err.response && err.response.data;
  if (data && data.errors && typeof data.errors === "object") {
    const campos = Object.keys(data.errors).map((k) => data.errors[k]);
    if (campos.length) return campos.join(" · ");
  }
  if (data && data.error) return data.error;
  return padrao || "Não foi possível concluir.";
}
